import React, { Component } from 'react'
import { connect } from 'react-redux'
import { translate } from 'react-i18next'
import { getApiData } from 'helpers/api'
import { DATASOURCE } from 'Constants'
import { Button, Icon } from 'semantic-ui-react'
import LadderChart from 'components/LadderChart'

class CallLadder extends Component {

  constructor(props) {
    super(props);
    this.getData = this.getData.bind(this);
    this.state = {noData: false};
  }

  componentDidMount() {
    if (this.props.callDetail.startTime)
    {
      if (this.props.ladderStore.data.length === 0) {
        this.getData();
      }
    } else {
      getApiData(DATASOURCE.DETAIL,this.props.location.search);
    }
  }

  componentDidUpdate(prevProps) {
    if (prevProps.callDetail.startTime !== this.props.callDetail.startTime) {
      this.getData();
    }
    if (prevProps.ladderStore.loading && !this.props.ladderStore.loading && this.props.ladderStore.data.length === 0) {
      this.setState({noData: true});
    }
  }

  getData() {
    let region = "SCUS";
    if (this.props.callDetail.startTime && 
      this.props.callDetail.protocol && this.props.callDetail.region)
    {
      switch(this.props.callDetail.region) {
        case "southcentralus": region = "SCUS"; break;
        case "westeurope": region = "WEU"; break;
        case "australiasoutheast": region="AUSE"; break;
        case "westus2": 
        default: region = "WUS2"; break;
      }
      let endDate = this.props.callDetail.endTime;
      if (!endDate) {
        let endms = (new Date()).getTime();
        endDate = new Date(endms + 5*60000).toISOString();
      } else {
        let endms = Date.parse(endDate);
        endDate = new Date(endms + 5*60000).toISOString();
      }
      let startms = Date.parse(this.props.callDetail.startTime);
      let startDate = new Date(startms - 5*60000).toISOString();
      if (!getApiData(DATASOURCE.LADDER,"",{
        "callId":this.props.callDetail.plcmTraceId,
        "type":this.props.callDetail.protocol,
        "startDate":startDate,
        "endDate":endDate,
        "region":region
      }) && this.props.ladderStore.data.length === 0)
      {
        this.setState({noData: true});
      }
    }
  }

  returnToSender() {
    let myUrl = this.props.location.pathname.replace("/CallLadder",'/CallDetail');
    this.props.history.push(myUrl + this.props.location.search);
  }

  render() {
    return (
      <div>
        <Button onClick={() => this.returnToSender()}><Icon name="undo"/> Return to Detail</Button>
        <h2>Call Ladder [{this.props.callDetail.plcmTraceId}]</h2>
        {this.state.noData && 
          <p>No data for this call. Very recent calls and calls older than 30 days may not be in the records.</p>
        }
        <LadderChart
          loading={this.props.ladderStore.loading || this.props.detailLoading}
          data={this.props.ladderStore.data}
          width="1000"
          height="500"
        />
      </div>
    )
  }
}

//REDUX STATE
const mapToProps = state => {
  return {
    ladderStore: state.ladder,
    callDetail: state.callDetail.data,
    detailLoading: state.callDetail.loading
  }
}

export default translate()(
  connect(
    mapToProps,
    null
  )(CallLadder)
);
